/* Levvel5 Delicacy theme behaviour.
   Products, prices and the cart come from Shopify: sections render them in Liquid,
   and the cart drawer talks to the Ajax Cart API. window.L5 is set in layout/theme.liquid. */
(() => {
  const L5 = window.L5 || {};
  const FREE_SHIP = L5.freeShip || 0; // in cents
  const routes = L5.routes || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };

  /* ---------- helpers ---------- */
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const esc = s => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // "Pack of 5 (Save ₹65)" → 5, "Single" → 1
  const packCount = title => { const m = /\d+/.exec(title || ''); return m ? +m[0] : 1; };
  // "Dal Makhani - Ready To Eat" → "Dal Makhani" (mirrors snippets/short-title.liquid)
  const shortTitle = t => String(t).split(' - ')[0].replace(/\s*ready to eat\s*$/i, '').trim();

  // Formats cents with the shop's money format, dropping ".00" like money_without_trailing_zeros
  function money(cents) {
    const fmt = L5.moneyFormat || '₹{{amount}}';
    const value = Number(cents) / 100;
    const group = (dec, thou, point) => {
      const [int, frac] = value.toFixed(dec).split('.');
      return int.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (frac ? point + frac : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return group(0, ',', '.');
        case 'amount_with_comma_separator': return group(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return group(0, ' ', ',');
        case 'amount_with_space_separator': return group(2, ' ', ',');
        default: return group(2, ',', '.');
      }
    }).replace(/[.,]00(?!\d)/, '');
  }

  async function api(url, body) {
    const res = await fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
    return data;
  }

  /* ---------- pack picker (cards and product page) ---------- */
  function setPack(scope, btn) {
    $$('.packs button', scope).forEach(b => b.setAttribute('aria-pressed', b === btn));
    const n = +btn.dataset.n || 1;
    const price = +btn.dataset.price;
    const unit = +scope.dataset.unit || price;
    const struck = n > 1 ? unit * n : +btn.dataset.compare;
    $('.item-price', scope).innerHTML =
      (struck > price ? `<s>${money(struck)}</s>` : '') + `<strong>${money(price)}</strong>` +
      (n > 1 ? `<span class="per">${money(Math.floor(price / n))} a pouch</span>` : '');
    const add = $('[data-add]', scope);
    if (add) add.dataset.add = btn.dataset.variant;
    const input = $('input[name="id"]', scope);
    if (input) {
      input.value = btn.dataset.variant;
      const url = new URL(location.href);
      url.searchParams.set('variant', btn.dataset.variant);
      history.replaceState(null, '', url);
    }
  }
  document.addEventListener('click', e => {
    const b = e.target.closest('.packs button');
    if (b && !b.disabled) setPack(b.closest('[data-pack-scope]'), b);
  });

  /* ---------- tabs (occasion picker, cooking methods) ---------- */
  function selectTab(tab) {
    const list = tab.closest('[role="tablist"]');
    $$('[role="tab"]', list).forEach(t => {
      const on = t === tab;
      t.setAttribute('aria-selected', on);
      t.tabIndex = on ? 0 : -1;
      const panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
  }
  document.addEventListener('click', e => {
    const t = e.target.closest('[role="tab"][aria-controls]');
    if (t) selectTab(t);
  });
  document.addEventListener('keydown', e => {
    const t = e.target.closest('[role="tab"][aria-controls]');
    if (!t) return;
    const tabs = $$('[role="tab"]', t.closest('[role="tablist"]'));
    const cur = tabs.indexOf(t);
    let next = null;
    if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = (cur + 1) % tabs.length;
    if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = (cur - 1 + tabs.length) % tabs.length;
    if (next !== null) { e.preventDefault(); selectTab(tabs[next]); tabs[next].focus(); }
  });

  /* ---------- bestseller shelf arrows ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-scroll]');
    if (!b) return;
    const track = $('.shelf-track', b.closest('.shelf'));
    track.scrollBy({ left: +b.dataset.scroll * track.clientWidth * 0.8, behavior: reduceMotion ? 'auto' : 'smooth' });
  });

  /* ---------- menu index hover peek ---------- */
  if (window.matchMedia('(pointer: fine)').matches) {
    document.addEventListener('mousemove', e => {
      const list = e.target.closest('.menu-list');
      const peek = $('#menuPeek');
      if (!peek) return;
      const a = list && e.target.closest('[data-peek]');
      if (!a) { peek.classList.remove('is-on'); return; }
      const slot = $('.menu-peek-slot', peek);
      if (slot.dataset.for !== a.dataset.peek) {
        slot.dataset.for = a.dataset.peek;
        const tpl = a.parentElement.querySelector('template');
        slot.innerHTML = tpl ? tpl.innerHTML : '';
      }
      peek.style.left = (e.clientX + 170) + 'px';
      peek.style.top = e.clientY + 'px';
      peek.classList.add('is-on');
    });
  }

  /* ---------- 90-second dial ---------- */
  function initDial(root) {
    const dial = $('#dial', root);
    if (!dial || dial.dataset.ready) return;
    dial.dataset.ready = '1';
    const DIAL_LEN = 2 * Math.PI * 88;
    const dialFill = $('#dialFill'), dialNum = $('#dialNum'), dialBtn = $('#dialBtn');
    const stepEls = $$('#steps li');
    const total = +dial.dataset.seconds || 90;
    const startLabel = dialBtn.textContent;
    dialFill.style.strokeDasharray = DIAL_LEN;
    let timer = null, elapsed = 0;

    function paintDial() {
      dialNum.textContent = total - elapsed;
      dialFill.style.strokeDashoffset = DIAL_LEN * (elapsed / total);
      let current = -1;
      stepEls.forEach((li, i) => { if (elapsed >= +li.dataset.at) current = i; });
      stepEls.forEach((li, i) => {
        li.classList.toggle('is-now', timer !== null && i === current);
        li.classList.toggle('is-done', timer !== null && i < current);
      });
    }
    function stopDial(label) {
      clearInterval(timer); timer = null;
      dialBtn.textContent = label;
    }
    dialBtn.addEventListener('click', () => {
      if (timer) { stopDial(startLabel); elapsed = 0; paintDial(); return; }
      if (elapsed >= total) elapsed = 0;
      dialBtn.textContent = 'Reset';
      timer = setInterval(() => {
        elapsed++;
        paintDial();
        if (elapsed >= total) {
          stopDial('Run it again');
          stepEls.forEach(li => li.classList.remove('is-done'));
          if (stepEls.length) stepEls[stepEls.length - 1].classList.add('is-now');
          dialNum.textContent = '0';
        }
      }, 1000);
      paintDial();
    });
  }

  /* ---------- cart ---------- */
  let cart = L5.cart || { items: [], item_count: 0, total_price: 0 };
  const cartEl = $('#cart'), scrim = $('#scrim'), toast = $('#toast');
  let pool = [];
  try { pool = JSON.parse($('#cartPool').textContent); } catch (err) { pool = []; }

  const thumb = l => l.image
    ? `<img class="ci-img" src="${esc(l.image + (l.image.includes('?') ? '&' : '?') + 'width=120')}" alt="" width="52" height="69" loading="lazy">`
    : `<div class="pouch pouch--mini"><span class="pouch-name">${esc(shortTitle(l.product_title))}</span></div>`;

  function suggestions(gap) {
    const inCart = new Set(cart.items.map(l => l.product_id));
    const seen = new Set();
    return pool
      .filter(o => o.price >= gap && !inCart.has(o.p))
      .sort((a, b) => a.price - b.price)
      .filter(o => !seen.has(o.p) && seen.add(o.p))
      .slice(0, 3);
  }

  function renderCart() {
    const total = cart.total_price;
    const n = cart.item_count;
    $$('[data-cart-count]').forEach(el => { el.textContent = n; });
    $('#cartTotal').innerHTML = money(total);
    $('#checkoutBtn').disabled = n === 0;

    const gap = Math.max(0, FREE_SHIP - total);
    const shipText = $('#shipText');
    if (shipText) {
      shipText.innerHTML = total === 0
        ? `Orders above ${money(FREE_SHIP)} ship free.`
        : gap > 0 ? `${money(gap)} more and your shipping is free.` : 'Your order ships free.';
      $('#shipFill').style.width = Math.min(100, (total / FREE_SHIP) * 100) + '%';
    }

    const list = $('#cartItems');
    if (!cart.items.length) {
      list.innerHTML = $('#cartEmptyTpl').innerHTML;
    } else {
      list.innerHTML = cart.items.map(l => {
        const name = shortTitle(l.product_title);
        const packs = packCount(l.variant_title);
        const meta = l.product_has_only_default_variant ? '' : (packs === 1 ? 'Single pouch, ' : `Pack of ${packs}, `);
        return `<li>
          ${thumb(l)}
          <div><p class="ci-name"><a href="${esc(l.url)}">${esc(name)}</a></p><p class="ci-meta">${meta}${money(l.final_price)}</p></div>
          <div class="qty" role="group" aria-label="Quantity of ${esc(name)}">
            <button data-line="${esc(l.key)}" data-qty="${l.quantity - 1}" aria-label="Remove one">−</button>
            <span>${l.quantity}</span>
            <button data-line="${esc(l.key)}" data-qty="${l.quantity + 1}" aria-label="Add one">+</button>
          </div>
        </li>`;
      }).join('');
    }

    const sug = $('#cartSuggest');
    if (FREE_SHIP && total > 0 && gap > 0) {
      const opts = suggestions(gap);
      sug.innerHTML = opts.length ? `<h3>Any of these gets you free shipping</h3><ul>${opts.map(o =>
        `<li><button class="dish-tag" data-add="${o.id}">${esc(shortTitle(o.t))}${o.n > 1 ? ' ×' + o.n : ''}, ${money(o.price)}</button></li>`
      ).join('')}</ul>` : '';
    } else sug.innerHTML = '';

    const mbarText = $('#mbarText');
    if (FREE_SHIP) {
      mbarText.innerHTML = n === 0
        ? `Free shipping above ${money(FREE_SHIP)}`
        : gap > 0 ? `${money(total)} in cart, ${money(gap)} to free shipping` : `${money(total)} in cart, ships free`;
    } else {
      mbarText.innerHTML = n === 0 ? '' : `${money(total)} in cart`;
    }
  }

  // the /cart page is rendered by Liquid, so reload it after the drawer changes the cart
  const syncCartPage = () => { if (document.body.dataset.page === 'cart') location.reload(); };

  function bumpCount() {
    $$('[data-cart-count]').forEach(el => { el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); });
  }

  async function addItems(items) {
    try {
      const added = await api(routes.cartAdd + '.js', { items });
      cart = await api(routes.cart + '.js');
      renderCart();
      bumpCount();
      syncCartPage();
      return added.items || [];
    } catch (err) {
      showToast(err.message, true);
      return null;
    }
  }

  $('#cartItems').addEventListener('click', async e => {
    const b = e.target.closest('[data-line]');
    if (!b) return;
    $$('[data-line]', cartEl).forEach(x => { x.disabled = true; });
    try {
      cart = await api(routes.cartChange + '.js', { id: b.dataset.line, quantity: +b.dataset.qty });
      syncCartPage();
    } catch (err) {
      showToast(err.message, true);
    }
    renderCart();
  });

  // the header is looked up each time because the theme editor can re-render it
  const setCartExpanded = on => { const b = $('#cartBtn'); if (b) b.setAttribute('aria-expanded', on); };
  let lastFocus = null;
  function openCart() {
    lastFocus = document.activeElement;
    toast.classList.remove('is-on');
    cartEl.classList.add('is-open'); cartEl.setAttribute('aria-hidden', 'false');
    scrim.hidden = false;
    setCartExpanded(true);
    $('#cartClose').focus();
  }
  function closeCart() {
    cartEl.classList.remove('is-open'); cartEl.setAttribute('aria-hidden', 'true');
    scrim.hidden = true;
    setCartExpanded(false);
    if (lastFocus) lastFocus.focus();
  }
  $('#cartClose').addEventListener('click', closeCart);
  scrim.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && cartEl.classList.contains('is-open')) closeCart(); });

  const flashAdded = el => {
    if (!el.classList.contains('btn') && !el.classList.contains('add-mini')) return;
    const old = el.textContent;
    el.classList.add('is-added'); el.textContent = 'Added';
    setTimeout(() => { el.classList.remove('is-added'); el.textContent = old; }, 1400);
  };

  // global add / open-cart delegation
  document.addEventListener('click', async e => {
    const add = e.target.closest('[data-add]');
    if (add) {
      e.preventDefault();
      if (add.disabled || add.getAttribute('aria-busy') === 'true') return;
      add.setAttribute('aria-busy', 'true');
      const added = await addItems([{ id: +add.dataset.add, quantity: 1 }]);
      add.removeAttribute('aria-busy');
      if (added && added[0]) {
        const it = added[0], packs = packCount(it.variant_title);
        showToast(`${shortTitle(it.product_title)}${packs > 1 ? ` (${packs} pack)` : ''} added.`);
        flashAdded(add);
      }
      return;
    }
    const many = e.target.closest('[data-add-many]');
    if (many) {
      e.preventDefault();
      // format: "variantId" or "variantId:qty", comma separated
      const items = many.dataset.addMany.split(',').map(s => { const [id, q] = s.split(':'); return { id: +id, quantity: +(q || 1) }; });
      const added = await addItems(items);
      if (added) {
        const what = items.length === 2 ? 'Both' : items.length > 2 ? `All ${items.length}` : 'It’s';
        showToast(FREE_SHIP && cart.total_price >= FREE_SHIP ? `${what} added. Your order ships free.` : `${what} added to your cart.`);
      }
      return;
    }
    if (e.target.closest('[data-open-cart]')) { e.preventDefault(); openCart(); }
  });

  // product page form: add without leaving the page
  document.addEventListener('submit', async e => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = $('[type="submit"]', form);
    btn.setAttribute('aria-busy', 'true');
    const qty = Math.max(1, parseInt($('[name="quantity"]', form)?.value, 10) || 1);
    const added = await addItems([{ id: +$('[name="id"]', form).value, quantity: qty }]);
    btn.removeAttribute('aria-busy');
    if (added && added[0]) {
      const it = added[0], packs = packCount(it.variant_title);
      showToast(`${qty > 1 ? qty + ' × ' : ''}${shortTitle(it.product_title)}${packs > 1 ? ` (${packs} pack)` : ''} added.`);
      flashAdded(btn);
    }
  });
  document.addEventListener('click', e => {
    const step = e.target.closest('[data-step]');
    if (!step) return;
    const input = $('input', step.parentElement);
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + +step.dataset.step);
  });

  // product page gallery thumbnails swap the main image
  document.addEventListener('click', e => {
    const t = e.target.closest('[data-thumb]');
    if (!t) return;
    e.preventDefault();
    const img = $('.pdp-main img');
    if (!img) return;
    img.removeAttribute('srcset');
    img.src = t.href;
  });

  /* ---------- toast ---------- */
  let toastT;
  function showToast(msg, isError = false) {
    toast.classList.toggle('is-error', isError);
    toast.innerHTML = `<span>${esc(msg)}</span>` + (isError ? '' : '<button type="button" data-open-cart>View cart</button>');
    toast.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(() => toast.classList.remove('is-on'), isError ? 5000 : 3200);
  }

  /* ---------- catalog sort ---------- */
  document.addEventListener('change', e => {
    if (!e.target.matches('[data-sort]')) return;
    const url = new URL(location.href);
    url.searchParams.set('sort_by', e.target.value);
    url.searchParams.delete('page');
    location.href = url;
  });

  /* ---------- mobile nav ---------- */
  function initNav() {
    const menuBtn = $('.menu-btn'), nav = $('#mainNav'), head = $('.site-head');
    if (!menuBtn || menuBtn.dataset.ready) return;
    menuBtn.dataset.ready = '1';
    const setHeadH = () => document.documentElement.style.setProperty('--head-h', head.getBoundingClientRect().bottom + 'px');
    menuBtn.addEventListener('click', () => {
      setHeadH();
      const open = nav.classList.toggle('is-open');
      menuBtn.setAttribute('aria-expanded', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
    nav.addEventListener('click', e => {
      if (e.target.closest('a') && nav.classList.contains('is-open')) {
        nav.classList.remove('is-open'); menuBtn.setAttribute('aria-expanded', 'false'); document.body.style.overflow = '';
      }
    });
  }

  /* ---------- mobile cart bar appears once the first section scrolls away ---------- */
  const mbar = $('#mbar');
  const firstSec = $('#main > .shopify-section');
  if (mbar && firstSec) new IntersectionObserver(([en]) => {
    const on = !en.isIntersecting;
    mbar.classList.toggle('is-on', on);
    document.body.classList.toggle('has-mbar', on && window.innerWidth <= 900);
  }).observe(firstSec);

  /* ---------- get in touch page ---------- */
  // Are we open right now? Hours come from the section settings, in India time.
  function initOpenStatus(root) {
    const status = $('#openStatus', root);
    if (!status || status.dataset.ready) return;
    status.dataset.ready = '1';
    {
      const openAt = +status.dataset.open, closeAt = +status.dataset.close;
      const closedDay = status.dataset.closedDay;
      const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Asia/Kolkata', weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false
      }).formatToParts(new Date()).map(p => [p.type, p.value]));
      const mins = (+parts.hour % 24) * 60 + +parts.minute;
      const day = parts.weekday;
      const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      const tomorrow = days[(days.indexOf(day) + 1) % 7];
      const open = day !== closedDay && mins >= openAt * 60 && mins < closeAt * 60;
      const at = h => h === 12 ? '12 noon' : h > 12 ? `${h - 12} pm` : `${h} am`;
      let when;
      if (day === closedDay || (tomorrow === closedDay && mins >= closeAt * 60)) {
        when = `We’re back on ${dayNames[(days.indexOf(closedDay) + 1) % 7]} at ${at(openAt)}.`;
      } else if (mins < openAt * 60) when = `We open today at ${at(openAt)}.`;
      else when = `We’re back tomorrow at ${at(openAt)}.`;
      status.classList.add(open ? 'is-open' : 'is-closed');
      status.innerHTML = open
        ? '<span class="dot" aria-hidden="true"></span>Open now. Call and someone will pick up.'
        : `<span class="dot" aria-hidden="true"></span>Closed right now. ${esc(when)} Messages sent now are answered first.`;
    }
  }

  function initContact(root) {
    const cform = $('#cform', root);
    if (!cform || cform.dataset.ready) return;
    cform.dataset.ready = '1';

    // Show only the fields the chosen topic needs
    const showTopic = t => $$('.topic-fields', cform).forEach(f => { f.hidden = f.dataset.for !== t; });
    cform.addEventListener('change', e => { if (e.target.name === 'contact[topic]') showTopic(e.target.value); });
    const pick = t => { const r = cform.querySelector(`input[name="contact[topic]"][value="${CSS.escape(t)}"]`); if (r) { r.checked = true; showTopic(t); } };
    const pre = new URLSearchParams(location.search).get('topic');
    if (pre) pick(pre);
    const bulkBtn = $('#bulkBtn');
    if (bulkBtn) bulkBtn.addEventListener('click', e => {
      e.preventDefault();
      pick('bulk');
      $('#contactForm').scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth' });
      setTimeout(() => cform.querySelector('[name="contact[name]"]').focus({ preventScroll: true }), reduceMotion ? 0 : 500);
    });

    // After Shopify posts the form and reloads, personalise the thank-you note
    const done = $('#formDone');
    if (done && !done.hidden) {
      const replies = {
        order: 'We’ll look up your order and get back to you within one working day.',
        product: 'We’ll reply with the dishes that suit you within one working day.',
        bulk: 'Someone from our team will call you to talk quantities and pricing.',
        other: 'We’ll get back to you within one working day.'
      };
      try {
        const sent = JSON.parse(sessionStorage.getItem('l5-contact') || 'null');
        if (sent) $('#formDoneText').textContent = `Thanks, ${sent.name}. ${replies[sent.topic] || replies.other}`;
        sessionStorage.removeItem('l5-contact');
      } catch (err) { /* storage unavailable: keep the generic note */ }
      done.focus();
    }

    // Validation with plain-language messages; valid forms post to Shopify as normal
    const phoneOk = v => /^(\+?91[\s-]?)?[6-9]\d{4}\s?\d{5}$/.test(v.trim());
    const messages = {
      'contact[name]': 'Please tell us your name.',
      'contact[phone]': 'Please enter a 10-digit mobile number.',
      'contact[email]': 'Please enter an email address we can reply to.',
      'contact[body]': 'Please write a short message.'
    };
    const setError = (input, msg) => {
      const field = input.closest('.field');
      let err = field.querySelector('.err');
      if (msg) {
        if (!err) { err = document.createElement('small'); err.className = 'err'; err.id = input.name.replace(/\W/g, '') + 'Err'; field.appendChild(err); }
        err.textContent = msg;
        input.setAttribute('aria-invalid', 'true');
        input.setAttribute('aria-describedby', err.id);
      } else {
        if (err) err.remove();
        input.removeAttribute('aria-invalid');
        input.removeAttribute('aria-describedby');
      }
    };
    const check = input => {
      const v = input.value.trim();
      let bad = !v;
      if (!bad && input.type === 'email') bad = !input.checkValidity();
      if (!bad && input.type === 'tel') bad = !phoneOk(v);
      setError(input, bad ? messages[input.name] : '');
      return !bad;
    };
    cform.addEventListener('blur', e => { if (e.target.matches('[required]') && e.target.value) check(e.target); }, true);
    cform.addEventListener('submit', e => {
      const req = $$('[required]', cform);
      const results = req.map(check);
      const firstBad = req[results.indexOf(false)];
      if (firstBad) { e.preventDefault(); firstBad.focus(); return; }
      try {
        sessionStorage.setItem('l5-contact', JSON.stringify({
          name: cform.querySelector('[name="contact[name]"]').value.trim().split(' ')[0],
          topic: (cform.querySelector('input[name="contact[topic]"]:checked') || {}).value
        }));
      } catch (err) { /* storage unavailable: the generic thank-you still shows */ }
    });
  }

  /* ---------- policy pages: contents list follows the reading position ---------- */
  // The current section is the last one whose top has passed a line just under the sticky header.
  // Clicking an entry marks it straight away, because short sections near the end of the page
  // can never scroll up to that line.
  function initToc(root) {
    const toc = $('#toc', root);
    if (!toc || toc.dataset.ready) return;
    toc.dataset.ready = '1';
    const links = $$('a', toc);
    const secs = links.map(a => document.getElementById(decodeURIComponent(a.hash.slice(1)))).filter(Boolean);
    if (!secs.length) return;
    const mark = id => links.forEach(a => a.toggleAttribute('aria-current', a.hash === '#' + encodeURIComponent(id) || a.hash === '#' + id));
    let clickedAt = 0, clickedId = null;
    const update = () => {
      if (Date.now() - clickedAt < 1200) return; // let the jump settle
      const atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
      if (atBottom && clickedId) return; // the jump ended at the bottom: keep what was clicked
      clickedId = null;
      const head = $('.section-header');
      const line = (head ? head.getBoundingClientRect().bottom : 0) + 140;
      let cur = secs[0];
      secs.forEach(s => { if (s.getBoundingClientRect().top <= line) cur = s; });
      if (atBottom) cur = secs[secs.length - 1];
      mark(cur.id);
    };
    toc.addEventListener('click', e => {
      const a = e.target.closest('a');
      if (!a) return;
      clickedAt = Date.now();
      clickedId = decodeURIComponent(a.hash.slice(1));
      mark(clickedId);
    });
    let queued = false;
    window.addEventListener('scroll', () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; update(); });
    }, { passive: true });
    if (location.hash && secs.some(s => '#' + s.id === decodeURIComponent(location.hash))) {
      clickedAt = Date.now();
      clickedId = decodeURIComponent(location.hash.slice(1));
      mark(clickedId);
    } else update();
  }

  /* ---------- start, and restart sections the theme editor re-renders ---------- */
  function init(root = document) {
    initDial(root);
    initToc(root);
    initOpenStatus(root);
    initContact(root);
    initNav();
  }
  init();
  renderCart();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
